import React, { useEffect, useRef, useState } from 'react';
const TOTAL_SECONDS = 17 * 60 + 34; // 00:17:34

type CountdownProps = {
  tone?: 'dark' | 'light';
};
function pad(value: number) {
  return String(value).padStart(2, '0');
}
export function Countdown({
  tone = 'dark'
}: CountdownProps) {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  const intervalRef = useRef<number | null>(null);
  useEffect(() => {
    intervalRef.current = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => {
      if (intervalRef.current) window.clearInterval(intervalRef.current);
    };
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const isDark = tone === 'dark';
  const boxClass = isDark ? 'bg-graphite text-white ring-1 ring-white/10' : 'bg-ink text-white';
  const labelClass = isDark ? 'text-white/50' : 'text-white/55';
  const units = [{
    value: pad(hours),
    label: 'Hours'
  }, {
    value: pad(minutes),
    label: 'Min'
  }, {
    value: pad(seconds),
    label: 'Sec'
  }];
  return <div className="w-full" data-id="element-20" data-mp="t1tnxwhhhiae">
      <p className={`text-center text-[11px] font-bold uppercase tracking-[0.18em] ${isDark ? 'text-white/60' : 'text-graphite/60'}`} data-id="element-21" data-mp="17qzvc7qh6etd">
        ⏳ The offer ends in
      </p>
      <div className="mt-3 flex items-stretch justify-center gap-2" role="timer" aria-live="off" data-id="element-22" data-mp="f22e87y02o27">
        {units.map(unit => <div key={unit.label} className={`flex min-w-[68px] flex-col items-center rounded-xl px-3 py-2.5 sm:min-w-[80px] ${boxClass}`} data-id="element-23" data-mp="a526ztpezf9i">
            <span className="font-display text-2xl font-bold tabular-nums sm:text-3xl" data-id="element-24" data-mp="k0m2wg3zady9">
              {unit.value}
            </span>
            <span className={`mt-0.5 text-[9px] font-bold uppercase tracking-[0.16em] ${labelClass}`} data-id="element-25" data-mp="1zk8o7fyqgjr2">
              {unit.label}
            </span>
          </div>)}
      </div>
      <p className={`mt-3 text-center text-[11px] font-semibold uppercase tracking-[0.14em] ${isDark ? 'text-blood' : 'text-blood'}`} data-id="element-26" data-mp="x4rclj7nj9xr">
        Limited launch pricing
      </p>
    </div>;
}